<template>
    <v-row class="text-no-wrap">
        <v-col> 등록일 : {{ createdAt }} </v-col>
        <v-col> 서명일 : {{ signedAt }} </v-col>
    </v-row>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initEmploymentContract },
    },
    computed: {
        createdAt() {
            return this.$dayjs(this.value?.createdAt).format("YYYY. MM. DD. HH:mm");
        },
        signedAt() {
            return this.value?.signedForm?.createdAt ? this.$dayjs(this.value?.signedForm?.createdAt).format("YYYY. MM. DD. HH:mm") : "-";
        },
    },
};
</script>

<style></style>
